/*
 * @Author: jixiaoyong
 * @Email: jixiaoyong1995@gmail.com
 * @Date: 23/07/29
 * @LastEditors: jixiaoyong
 * @LastEditTime: 24/05/30
 * @FilePath: /app_list/src/main.js
 * @Description:
 *
 * Copyright (c) 2024 by jixiaoyong, All Rights Reserved.
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/routers";

const app = createApp(App);
app.use(router);
app.mount("#app");
